import FloatingVue from 'floating-vue';
import { defineNuxtPlugin } from 'nuxt/app';

// This is the only place floating-vue is installed — `floating-vue/nuxt` is left out of the module's
// dependencies on purpose (see `module.ts`), because its themeless `app.use` would win the
// `$_vTooltipInstalled` guard and swallow the custom themes below.
//
// The plugin must stay UNIVERSAL. `install` is what registers the `v-tooltip` (InputMask, InputNumber)
// and `v-close-popper` (~20 call sites, plus Copyright.vue) directives, and an unresolved custom
// directive is a hard throw during SSR — @vue/server-renderer's `ssrGetDirectiveProps` reads
// `getSSRProps` straight off the resolved directive — so `mode: 'client'` white-pages the SSR'd apps
// (legal, help, mar's public routes). Running on the server is safe: floating-vue guards every
// window/document access and imports nothing but `vue` and `@floating-ui/dom`.
//
// Keep the themes as nested objects: `install` deep-merges them into the default config, so the
// built-in `triggers`/`hideTriggers`/`autoHide` on `tooltip` and `dropdown` survive. Replacing a theme
// wholesale would strip its `triggers` array and reintroduce the crash this file exists to prevent.
export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.use(FloatingVue, {
		themes: {
			tooltip: {
				placement: 'top',
				distance: 12,
				preventOverflow: true,
				overflowPadding: 16,
			},
			dropdown: {
				placement: 'bottom',
				distance: 8,
				preventOverflow: true,
				overflowPadding: 16,
			},
			user: {
				$extend: 'dropdown',
				placement: 'bottom-end',
				distance: 16,
				arrowDistance: 24,
			},
			id: {
				$extend: 'tooltip',
				placement: 'top',
				distance: 0,
				flip: false,
				shift: false,
				hideTriggers: (triggers: string[]) => triggers.filter(t => t !== 'click'),
			},
			action: {
				$extend: 'tooltip',
				placement: 'top',
				distance: 8,
				flip: true,
				shift: true,
				handleResize: true,
				hideTriggers: (triggers: string[]) => triggers.filter(t => t !== 'click'),
			},
		},
	});
});
